import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  AccordionSummary,
  Typography,
  AccordionDetails,
  Accordion, Fade
} from '@material-ui/core'
import { useStyles } from './Styles'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined'
import { FormLoader } from '../Loader/FormLoader'
import Odometer from 'react-odometerjs'
import 'odometer/themes/odometer-theme-default.css'

const AmountBox = ({ issuer, amounts, loading }) => {
  const classes = useStyles()
  const [amountsVal, setAmountsVal] = React.useState({})

  React.useEffect(() => {
      if (!!Object.keys(amounts || {}).length) {
        setAmountsVal(amounts)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [amounts])
  return (
    <div className={classes.AmountBoxWrapper}>
      <Accordion expanded={true} elevation={4} className={classes.AmountBox + (!!issuer ? ' issuer' : ' receiver')}>
        <AccordionSummary
          expandIcon={<></>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.AmountBoxHeadingWrapper}>
            <Typography className={classes.ItemHeading} component={'h3'} variant={'h6'}>{!!issuer ?
              <ArrowUpwardOutlinedIcon color={'primary'}/> :
              <ArrowDownwardOutlinedIcon color={'secondary'}/>}<FormattedMessage
              id={`dashboard.AmountBox.Title.${!!issuer ? 'issuer' : 'receiver'}`}/></Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          {!!loading && <FormLoader loading={loading}/>}
          <Fade in={!!Object.keys(amounts || {})?.length}>
            <div className={classes.AmountBoxContent}>
              {Object.keys(amounts || {})?.map((amountKey, index) =>
                <div key={index} className={classes.AmountRow}>
                  <label><FormattedMessage id={`dashboard.AmountBox.amount.${amountKey}`}/></label>
                  <span className={classes.amountValue}>
                  <Odometer value={amountsVal[amountKey]?.count || 0}/>&nbsp;(<Odometer value={amountsVal[amountKey]?.amount || 0}/>&nbsp;<FormattedMessage id='EGP'/>)</span>
                </div
                >)}
            </div>
          </Fade>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default AmountBox
